<template>
  <div
    class="border-static-default-hi rounded-sm space-y-8 border px-12 pb-12 pt-24"
  >
    <div class="text-static-default-hi heading-2">
      {{ i18n(translations.title) }}
    </div>
    <div class="text-static-default-hi heading-2">
      {{ i18n.price(price, { maximumFractionDigits: 0 }) }}
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Price } from '@backmarket/http-api/src/api-models/Price'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import translations from './Proposal.translations'

const i18n = useI18n()

defineProps<{
  price: Price
}>()
</script>
